import type { IconProps } from './types';
import './icons.css';

export default function Info({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-info ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M10 17.708a7.708 7.708 0 1 0 0-15.416 7.708 7.708 0 0 0 0 15.416Z"
      />
      <path
        stroke="currentColor"
        d="M10 7.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM10 9.375v4.583"
      />
    </svg>
  );
}
